@let iconsDict = iconDefinitions() | keyvalue;

<div class="gridContainer">
	<div>
		<mat-button-toggle-group class="buttonToggleGroup" (change)="toggleIconColoring()">
			<mat-button-toggle [checked]="iconColoring() === 'active'" [value]="'active'">
				{{ T.RATING_ITEM_ICON_SET_ACTIVE_COLOR | translate }}
			</mat-button-toggle>
			<mat-button-toggle [checked]="iconColoring() === 'inactive'" [value]="'inactive'">
				{{ T.RATING_ITEM_ICON_SET_INACTIVE_COLOR | translate }}
			</mat-button-toggle>
		</mat-button-toggle-group>

		<div class="icons">
			@for (iconEntry of iconsDict; track iconEntry.key) {
				<button
					mat-icon-button
					class="iconChooserBtn"
					[class.selected]="$index == selectedIcon()"
					[style.color]="getColorForIconConfig(iconEntry.value)"
					(click)="selectedIcon.set($index)"
				>
					<mat-icon [fontSet]="iconEntry.value.icon.fontSet" [fontIcon]="iconEntry.value.icon.fontIcon" />
				</button>
			}
		</div>

		<div class="controls">
			<button mat-button color="warn" [disabled]="iconsDict.length <= 3" (click)="removeIcon()">
				<mat-icon class="buttonIcon" fontSet="fad" fontIcon="fa-minus" inline />
				{{ T.RATING_ITEM_ICON_SET_REMOVE_ICON | translate }}
			</button>

			<button mat-button color="accent" [disabled]="iconsDict.length >= 10" (click)="addIcon()">
				<mat-icon class="buttonIcon" fontSet="fad" fontIcon="fa-plus" inline />
				{{ T.RATING_ITEM_ICON_SET_ADD_ICON | translate }}
			</button>
		</div>
	</div>

	<form class="iconDefinitionControls">
		@let selectedIconFormGroup = this.form.controls[this.selectedIcon()];
		@if (selectedIconFormGroup) {
			<mat-radio-group class="fontSetRadioGroup" [formControl]="selectedIconFormGroup.controls.icon.controls.fontSet">
				<mat-radio-button value="fas">{{ T.RATING_ITEM_ICON_SET_FONT_AWESOME_SOLID | translate }}</mat-radio-button>
				<mat-radio-button value="far">{{ T.RATING_ITEM_ICON_SET_FONT_AWESOME_REGULAR | translate }}</mat-radio-button>
			</mat-radio-group>

			<mat-form-field>
				<mat-label>{{ T.RATING_ITEM_ICON_SET_ICON | translate }}</mat-label>
				<input matInput [formControl]="selectedIconFormGroup.controls.icon.controls.fontIcon" />
			</mat-form-field>

			<mat-form-field>
				<mat-label>{{ T.RATING_ITEM_ICON_SET_ACTIVE_COLOR | translate }}</mat-label>
				<input matInput [formControl]="selectedIconFormGroup.controls.activeColor" />
				<ngx-colors matSuffix ngx-colors-trigger [formControl]="selectedIconFormGroup.controls.activeColorPicker" />
				@if (selectedIconFormGroup.controls.activeColor.hasError("invalidColor")) {
					<mat-error>
						{{ T.RATING_ITEM_ICON_SET_INVALID_COLOR | translate }}
					</mat-error>
				}
			</mat-form-field>

			<mat-form-field>
				<mat-label>{{ T.RATING_ITEM_ICON_SET_INACTIVE_COLOR | translate }}</mat-label>
				<input matInput [formControl]="selectedIconFormGroup.controls.inactiveColor" />
				<ngx-colors matSuffix ngx-colors-trigger [formControl]="selectedIconFormGroup.controls.inactiveColorPicker" />
				@if (selectedIconFormGroup.controls.inactiveColor.hasError("invalidColor")) {
					<mat-error>
						{{ T.RATING_ITEM_ICON_SET_INVALID_COLOR | translate }}
					</mat-error>
				}
			</mat-form-field>
		}
	</form>
</div>
